<template>
  <div class="container">
        <div class="row">
            <div class="col-md-6 col-md-offset-3">
                <div class="login-panel panel panel-default">
                    <div class="panel-body" style="font-weight: bold;text-align: center;background-color: #F5F5F5;font-family: 'Tahoma';">
                        <form role="form">
                            <fieldset>
                              <div class="form-group" style="font-family: 'Tahoma';font-size: 85px;">
                                500
                              </div>
                              <div class="form-group" style="font-family: 'Tahoma';font-size: 35px;">
                                  خطأ فى النظام
                              </div>
                              <div class="form-group" style="font-family: 'Tahoma';font-size: 18px;">
                                  عفوا يوجد خطأ فى الصفحة, يرجى الاتصال بمدير النظام
                                </div>
                                <!-- Change this to a button or input when using this as a form -->
                                <button style="font-family: 'Tahoma';font-size: 22px;width: 100px" type="submit" class="btn btn-warning" @click.prevent="$router.push('/dashborad')" > رجوع </button>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Err404'
}
</script>



// WEBPACK FOOTER //
// src/components/errorPages/err500.vue